import { render, staticRenderFns } from "./ProviderTransaction.vue?vue&type=template&id=1b8c74e3"
import script from "./ProviderTransaction.vue?vue&type=script&lang=js"
export * from "./ProviderTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports